<template>
    <div class="news-item" v-if="content" v-on:click.stop="gotoDetail(content.contentId)">
        <div class="news-cover">
            <img v-lazy="content.picture" v-if="content.picture"/>
        </div>
        <div class="news-title">
            <p>{{content.contentTitle}}</p>
        </div>
        <!-- <div class="news-desc">
            <p>{{content.summary}}</p>
        </div> -->
    </div>

</template>
<script>
export default {
    props:{
        content: {
            type: Object,
            default: () => {},
        },
    },
    methods:{
        gotoDetail(contentId){
            this.$router.push("/newsDetail?contentId="+ contentId);
        }
    }
}
</script>

<style scoped>
.news-item{
    display: inline-block;
    width: 24.5%;
    cursor: pointer;
}
.news-cover{
    width: 278px;
    height: 240px;
    overflow: hidden;
}
.news-cover img{
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
}
.news-title, .news-desc{
     width: 278px;
}
.news-title p{
    width: 90%;
    margin-left: auto;
    margin-right: auto;
    font-size: 18px;
    font-weight: bold;
    margin-top: 12px;
    line-height: 26px;
    text-align: center;
}
.news-desc p{
    width: 85%;
    margin-left: auto;
    margin-right: auto;
    font-size: 16px;
    margin-top: 12px;
    text-indent:2em;
    line-height: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/NewsItem25.vue